(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["details"]) return;
  try {
    
function populate (){
  document.getElementById('product-shop-bt').innerHTML =  document.getElementById('meta-shop-link-us').innerHTML;
  document.getElementById('product-shop-mobile-bt').innerHTML = document.getElementById('meta-shop-link-us').innerHTML;
  document.getElementById('product-product-right-quantity').innerHTML = document.getElementById('meta-oz').innerHTML;
  // document.getElementById('product-dontforget-desc').innerHTML = document.getElementById('met-dont-forget').innerHTML;
  // document.getElementById('product-dontforget-img').innerHTML = document.getElementById('meta-dont-forget-image').innerHTML;
  // document.getElementById('product-hairgoals-quote').innerHTML = '&#8220;' + document.getElementById('meta-hairgoals-quote').innerHTML + '&#8221;';
  // document.getElementById('product-hairgoals-image-1').innerHTML = document.getElementById('meta-hairgoals-image-1').innerHTML;
  // document.getElementById('product-hairgoals-image-2').innerHTML = document.getElementById('meta-hairgoals-image-2').innerHTML;
  
  let tutorialImage = document.getElementById('meta-watch-the-tutorial-image').innerHTML;
  if(tutorialImage != '') {
    // document.getElementById('product-tutorial-video').innerHTML = document.getElementById('meta-watch-the-tutorial-image').innerHTML;

    let re = /\/\/cdn[^"]*/;
    let imageUrl = tutorialImage.match(re);
    document.getElementById('product-tutorial-video').style.background = 'url(' + imageUrl + ')';
    document.getElementById('product-tutorial-video').style.backgroundRepeat = 'no-repeat';
    document.getElementById('product-tutorial-video').style.backgroundSize = 'cover';
    document.getElementById('product-tutorial-video').style.backgroundPosition = 'center center';

  } else {
    document.getElementById('shopify-section-product-watch-the-tutorial').style.display = 'none';
  }
}

function relatedProducts() {
  let inputHtml = document.getElementById('meta-related-products').innerHTML;
  if (inputHtml) {
    inputHtml = inputHtml.replace(/ /g, '');
    let relatedProductsArr = inputHtml.split(',');
    let html = '';
    for (let productUrl of relatedProductsArr) {
      console.log('rp', productUrl);

      fetch( productUrl + '.js' )
        .then(function(response) {
          return response.json();
        })
        .then(function(product) {
          console.log('The title of this product is ' + product.title);
          html += `
          <a href="/products/${product.handle}">
            <div class="product-related-products-product">
              <div class="product-related-products-product-img">
                <img src="${product.featured_image}" alt="${product.title}">
              </div>
            <div class="product-related-products-product-name">
              ${product.title}
            </div>
            <div class="product-related-products-product-price">
              ${formatPrice(product.price)}
            </div>
            </div>
          </a>
          `;
          document.getElementById('product-related-products-container').innerHTML = html;
          formatRelatedProductNames();
        });
    }
  } else {
    document.getElementById('product-related-products').innerHTML = '';
    console.log('no related products meta found');
  }
};

function reviews () {
  let p_page_id = document.getElementById('meta-review-id').innerHTML;
  if (p_page_id) {
    document.getElementById('shopify-section-reviews').style.display = 'block';
    powerReviews(p_page_id);
  }
  console.log('reviews try 1');

  setTimeout( () => {
    // console.log('reviews timeout 1');
    p_page_id = document.getElementById('meta-review-id').innerHTML;
    if (p_page_id && document.getElementById('pr-reviewsnippet').innerHTML == '') {
      powerReviews(p_page_id);
      // console.log('reviews try 2');
    }
  } , 1000);

  setTimeout( () => {
      // console.log('reviews timeout 2');
    p_page_id = document.getElementById('meta-review-id').innerHTML;
    if (p_page_id && document.getElementById('pr-reviewsnippet').innerHTML == '') {
      powerReviews(p_page_id);
      // console.log('reviews try 3');
    }
  } , 2000);
}

function powerReviews (p_page_id){
  POWERREVIEWS.display.render({
    api_key: '6fd399a4-f162-41a0-86cd-229379648bce',
    locale: 'en_US',
    merchant_group_id: '49187',
    merchant_id: '492315',
    page_id: p_page_id,
    review_wrapper_url: '/pages/write-a-review?pr_page_id=' + p_page_id,
    components: {
      ReviewSnippet: 'pr-reviewsnippet',
      ReviewImageSnippet: 'pr-imagesnippet',
      ReviewDisplay: 'pr-reviewdisplay'
    }
  });
}

(function () {
  let pathArr = window.location.pathname.split('/');
  let pagePath = '/pages/' + pathArr[pathArr.length - 1] + '-details';
  fetch(pagePath)
    .then(function(response) {
      return response.text();
    })
  .then(function(page) {
    let html = page.split('MainContent">')[1].split('<iframe')[0];
    document.getElementById('meta-details').innerHTML = html;
    populate();
    relatedProducts();
    reviews();
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hairgoals"]) return;
  try {
    
$(function() {
    var sliderContainer = '#home-hairgoals-slider-container';
    var sliderImgsContainer = '#home-hairgoals-slider-imgs';
    var sliderControls = '#home-hairgoals-slider-controls';
    var cW = $('#home-hairgoals-slider-container').width();
    var numOfSlides = $('#home-hairgoals-slider-imgs img').length;
    var slidePosition = 0;
    var arrowClicked = false;
    $(sliderControls + ' a:nth-child(1)').css('background-position','0px');
    $( '#home-hairgoals-slider-imgs img:nth-child(1)' ).clone().appendTo( '#home-hairgoals-slider-imgs' );

    function sizeSliderImages () {
        // console.log($('#slider').width());
        var cW = $(sliderContainer).width();
        $(sliderImgsContainer).css('width', cW * (numOfSlides + 1) + "px");
        $(sliderImgsContainer + ' img').css('width', cW + "px");
    }

    function rePositionSlider() {
        var cW = $(sliderContainer).width();
        $(sliderImgsContainer).css('left', (slidePosition * cW) * -1 + "px");
    }
    function arrowLeft() {
        var cW = $(sliderContainer).width();
        var prevPosition = slidePosition;
        // console.log(slidePosition);
        // $('#slider').css('left', (slidePosition * cW)* -1 + "px");
        if(slidePosition === 0) {
          slidePosition = numOfSlides ;
          $(sliderImgsContainer).css('left', (slidePosition * cW)* -1 + "px");
        }
        
        slidePosition--;
        $(sliderControls + ' a').removeAttr('style');
        $(sliderControls + ' a:nth-child(' + (slidePosition + 1) + ')').css('background-position','0px');
        $(sliderImgsContainer).animate({
          left: (slidePosition * cW)* -1 + "px"
        },
          750);
        
    }

    function arrowRight() {
        var cW = $(sliderContainer).width();
        var prevPosition = slidePosition;
        slidePosition++;
        if(slidePosition > numOfSlides ){
            slidePosition = 0;
        }

        $(sliderImgsContainer).animate({
            left: (slidePosition * cW)* -1 + "px"
        },
        750,
        function() {
            if(slidePosition == numOfSlides){
                slidePosition = 0;
                $(sliderImgsContainer).css('left', "0px");
            }
            $(sliderControls + ' a').removeAttr('style');
            $(sliderControls + ' a:nth-child(' + (slidePosition + 1) + ')').css('background-position','0px');
        });

    }

    //slide show
    sizeSliderImages();
    setInterval(function() {
      //console.log( slidePosition);
        if(arrowClicked === false){
            arrowRight();
        } else {
            arrowClicked = false;
        }
    }, 5500);
    
    $(window).resize(function(){
        sizeSliderImages();
        rePositionSlider();
    });
    $('#home-hairgoals-slide-bt-2').click(()=>{
        arrowRight();
        arrowClicked = true;
        });
    $('#home-hairgoals-slide-bt-1').click(()=>{
        arrowLeft();
        arrowClicked = true;
        });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"]) return;
  try {
    
  $('.scrollDown').click(()=>{ 
    let scrollTo = $('#shopify-section-home-hero').height();
     $('html, body').animate({
          scrollTop: scrollTo
      }, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hairgoals-new"]) return;
  try {
    
function productHairgoals () {
  let hairgoalsHandle = document.getElementById('meta-hairgoals-handle');
  if(hairgoalsHandle){
    const hairgoal = hairgoalsJson.find( obj => obj.handle == "hairgoals/" + hairgoalsHandle.innerHTML );
    console.log('hairgoalsHandle: ' + hairgoalsHandle.innerHTML);
    console.log(hairgoal);
    document.getElementById('product-hairgoals-new').style.display = "block";
    // document.getElementById('product-hairgoals-heading').style.display = 'block';
    let image = document.getElementById('product-hairgoals-image');
    let title = document.getElementById('product-hairgoals-title');
    let text = document.getElementById('product-hairgoals-text');
    image.innerHTML = `<img src="${hairgoal.image}" alt="${hairgoal.title}">`;
    title.innerHTML = hairgoal.title;
    text.innerHTML = hairgoal.content;
  } else {
  }
}
setTimeout( () => {
  productHairgoals();
}, 1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-watch-the-tutorial"]) return;
  try {
    
  function openTutorialVideo () {
    console.log('click bt');
    let videoUrl = $('#meta-watch-the-tutorial-vimeo-url').html();
    var re = /\d\d\d\d\d\d+/;
    let vimeoId = videoUrl.match(re)[0];
    let html = `<iframe src="https://player.vimeo.com/video/${vimeoId}?autoplay=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>`;
    document.getElementById('product-tutorial-video').innerHTML = html;
    document.getElementById('product-tutorial-video').style.background = 'none';
    document.getElementById('product-tutorial-video-bt').style.display = 'none';
  }
  document.getElementById('product-tutorial-video-bt').addEventListener("click", () => {
    openTutorialVideo ();
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function productImageViewer(e){
    e.preventDefault();
    // console.log(e.target.dataset.productimagelarge);
    let largeImageUrl = $(e.target).data('productimagelarge');
    $('#product-product-image').attr("src", largeImageUrl);
  }

  $('#product-product-image-thumbs a img').click( e => { productImageViewer(e); });


  $('.directions-bt').click(e => { 
    let headline = document.getElementById('meta-directions-headline').innerHTML;
    let body = document.getElementById('meta-directions-body').innerHTML;
    let quote = document.getElementById('meta-directions-quote').innerHTML;

    let directions = `
    <div id="product-directions">
      <h3>DIRECTIONS FOR USE</h3>
      <h1>${headline}</h1>
      ${body}
      <div id="product-directions-quote-container">
        <h2>${quote}</h2>
        <div class="quote-source">- KRISTIN ESS</div>
      </div>
    </div>`;

    $('#popup-content').html(directions);
    popupOpen(e);
  })

  $('.ingredients-bt').click(e => {
    let ingredients =  $('#meta-ingredients').html();
    let html = `
      <div class="ingredients-header">
        <h3 class="ingredients-label">INGREDIENTS</h3>
        <div class="crulety-free-icon"></div>
      </div>
      <p class="ingredients">${ingredients}</p>
      `;
    $('#popup-content').html(html);
    popupOpen(e);
  })

  $('.zip-up-bt').click(e => { 
    let html = `
      <div class="zip-up-header">
      <h3 class="zip-up-label">CONTAINS ZIP-UP TECHNOLOGY&#8482;</h3>
      <div class="zip-up-icon"></div>
      </div>
      <p class="zip-up">Our proprietary strengthening complex designed to "zip-up" split ends while targeting weak areas of the hair, smoothing the appearance of damaged cuticles and helping to protect hair from environmental stressors and color fade.</p>
      `;
    $('#popup-content').html(html);
    popupOpen(e);
  });

  formatTitle(document.getElementById('product-product-right-name'));
  formatTitle(document.getElementById('product-product-mobile-name'));


$('#popup-container').click(() => {popupClose();}); //close pop on overlay click
$('#popup-close').click(() => {popupClose()}); //close popup on X click

  } catch(e) { console.error(e); }
})();

})();
